import React from 'react';
import classNames from 'classnames';

import Card from 'components/Card';
import Icon from 'components/Icon';
import Modal from 'components/Modal';
import ModalButton from 'components/ModalButton';
import ModalHeader from 'components/ModalHeader';

import { MODALS } from 'utils/constants';
import { ASSIGNMENT_STATES } from './../constants';

export default class AssignmentPinpointsReviewModal extends React.Component {
    render() {
        let { assignment, closeModal, modalThatIsOpen, openModal, openSelectionModal, removePinpoint, reviewCancel, reviewConfirm, show} = this.props;

        if(Object.keys(assignment).length > 0) {
            return (
                <Modal show={show}
                       className={classNames('assignment-pinpoints-review assignment-pinpoints-list',
                           {
                               'assignment-list': modalThatIsOpen === MODALS.ASSIGNMENT_PINPOINTS_LIST,
                               'assignment-review': modalThatIsOpen === MODALS.ASSIGNMENT_PINPOINTS_REVIEW,
                               'assignment-is-published': assignment.state === ASSIGNMENT_STATES.PUBLISHED
                           })}
                       handleClose={closeModal.bind(this)}
                       width="full">
                    <ModalHeader>
                        Review PinPoints
                    </ModalHeader>
                    {modalThatIsOpen === MODALS.ASSIGNMENT_PINPOINTS_REVIEW ? (
                            <div role="button"
                                 className="review-modal__add details-modal__info"
                                 onClick={openSelectionModal.bind(this)}>
                                <Icon icon="plus" /> Add PinPoints
                            </div>
                        ) : null}
                    {assignment.beacons.length > 0 ? (
                        <div className="cards">
                            {assignment.beacons.map((beacon) => {
                                if(beacon != null) {
                                    return <Card item={beacon}
                                                 onClick={removePinpoint.bind(this, beacon, 'beacons')}
                                                 type="beacon--review"
                                                 key={beacon.id}/>
                                } else {
                                    return null;
                                }
                            })}
                            <div className="card empty"></div>
                            <div className="card empty"></div>
                            <div className="card empty"></div>
                        </div>
                    ) : (
                        <div className="no-cards">
                            No PinPoints added to this assignment.
                        </div>
                    )}

                    {modalThatIsOpen === MODALS.ASSIGNMENT_PINPOINTS_REVIEW ? (
                        <div className="modal__buttons">
                            <ModalButton icon="check"
                                         onClick={reviewConfirm.bind(this)}
                                         text="Done" />
                            <ModalButton className="modal-button--cancel"
                                         icon="cancel"
                                         onClick={reviewCancel.bind(this)}
                                         text="Cancel" />
                        </div>
                    ) : (
                        <div className="modal__buttons">
                            <ModalButton icon="check"
                                         onClick={openModal.bind(this, MODALS.ASSIGNMENT_DETAILS)}
                                         text="Done"/>
                        </div>
                    )}
                </Modal>
            );
        } else {
            return null;
        }
    }
};



// WEBPACK FOOTER //
// ./src/containers/AssignmentsPage/modals/AssignmentPinpointsReviewModal.js